(function () {
    "use strict";
    angular.module('skillBuilderSaaS')
        .controller("AddManualScoreCtrl", ["onlineExamsHistoryResource", "messageService", "$state", "$translate", "$scope", "calendarSettingsService", addManualScoreCtrl]);
    function addManualScoreCtrl(onlineExamsHistoryResource, messageService, $state, $translate, $scope, calendarSettingsService) {
        var vm = this;
        vm.showErrors = false;
        vm.saving = false;
        vm.attemptData = {};
        //Date picker config
        vm.format = "yyyy-MM-dd";
        calendarSettingsService.calendarSetup($scope);
        vm.open = calendarSettingsService.open;
        //Future Date Validation
        vm.checkDate = calendarSettingsService.checkDate;
        vm.save = function (isValid) {
            vm.saving = true;
            if (isValid) {
                vm.attemptData.date = vm.date.toUTCString();
                onlineExamsHistoryResource.addManualScore({ person: $state.params.person, assignmentId: $state.params.assignmentId, activationNumber: $state.params.activationNumber }, vm.attemptData, function () {
                    messageService.success("evaluations.onlineExams.attemptsHistory.addManualScore.success");
                    $scope.$close();
                }, function (error) {
                    vm.saving = false;
                    messageService.error(error);
                });
            }
            else {
                vm.showErrors = true;
                vm.saving = false;
            }
        };
    }
}());
